export class LoyaltyOption {
  constructor ({ value, labelKey }) {
    this.value = value
    this.labelKey = labelKey
  }
}
